<template>
  <div class="min-h-screen bg-gradient-to-br from-primary via-primary-dark to-secondary flex flex-col lg:flex-row">
    <!-- Left side - Branding -->
    <div class="hidden lg:flex lg:w-1/2 items-center justify-center p-6 xl:p-12 animate-slide-in-left bg-gradient-to-br from-primary to-primary-dark relative overflow-hidden">
      <!-- Decorative background elements -->
      <div class="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-black/10 backdrop-blur-sm"></div>
      <div class="absolute -top-10 -right-10 w-40 h-40 bg-gradient-radial from-accent-light/30 to-transparent rounded-full blur-xl"></div>
      <div class="absolute -bottom-10 -left-10 w-32 h-32 bg-gradient-radial from-accent/20 to-transparent rounded-full blur-xl"></div>
      
      <div class="text-center text-white relative z-10 max-w-lg">
        <div class="mb-8 lg:mb-12">
          <EcomacLogo 
            variant="white" 
            size="large" 
            orientation="vertical" 
            :show-text="false"
          />
          <div class="w-20 h-1 bg-accent-light mx-auto mt-6 mb-6"></div>
        </div>
        <div class="space-y-4 lg:space-y-6 text-left max-w-md mx-auto">
          <div class="flex items-center space-x-3">
            <div class="w-2 h-2 bg-accent-light rounded-full flex-shrink-0"></div>
            <p class="text-lg lg:text-xl">Gestión de tickets de soporte</p>
          </div>
          <div class="flex items-center space-x-3">
            <div class="w-2 h-2 bg-accent-light rounded-full flex-shrink-0"></div>
            <p class="text-lg lg:text-xl">Seguimiento en tiempo real</p>
          </div>
          <div class="flex items-center space-x-3">
            <div class="w-2 h-2 bg-accent-light rounded-full flex-shrink-0"></div>
            <p class="text-lg lg:text-xl">Comunicación directa con el equipo</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Right side - Login Form -->
    <div class="w-full lg:w-1/2 flex items-center justify-center p-4 sm:p-6 lg:p-8 xl:p-12 relative">
      <!-- Mobile background pattern -->
      <div class="lg:hidden absolute inset-0 bg-gradient-to-b from-black/20 to-black/40"></div>
      
      <div class="w-full max-w-md relative z-10">
        <!-- Mobile logo -->
        <div class="lg:hidden text-center mb-8 sm:mb-10">
          <div class="mx-auto mb-4 flex justify-center items-center h-16 sm:h-20">
            <EcomacLogo 
              variant="white" 
              size="medium" 
              orientation="horizontal" 
              :show-text="false"
            />
          </div>
          <p class="text-white/90 text-sm sm:text-base">Portal de Soporte</p>
        </div>
        
        <!-- Login Card -->
        <div class="card animate-slide-in-right bg-white/95 lg:bg-white backdrop-blur-sm border border-white/20 lg:border-gray-200">
          <div class="text-center mb-6 sm:mb-8">
            <h2 class="text-xl sm:text-2xl font-semibold text-primary mb-2">Iniciar Sesión</h2>
            <p class="text-secondary text-sm sm:text-base">Accede a tu portal de soporte</p>
          </div>
          
          <!-- Test Credentials -->
          <div class="mb-4 sm:mb-6 p-3 sm:p-4 bg-gradient-light rounded-lg">
            <p class="font-medium text-ecomac-dark mb-2 sm:mb-3 text-center text-sm sm:text-base">Credenciales de Prueba MVP</p>
            <div class="space-y-2 text-xs sm:text-sm">
              <!-- Mobile: Stack layout -->
              <div class="sm:hidden space-y-2">
                <div class="p-2 bg-white bg-opacity-60 rounded border border-accent-light/20">
                  <div class="font-medium text-ecomac-primary mb-1">Cliente:</div>
                  <div class="font-mono text-xs">cliente@ecomac.cl</div>
                </div>
                <div class="p-2 bg-white bg-opacity-60 rounded border border-accent-light/20">
                  <div class="font-medium text-ecomac-primary mb-1">Líder:</div>
                  <div class="font-mono text-xs">lider@ecomac.cl</div>
                </div>
                <div class="p-2 bg-white bg-opacity-60 rounded border border-accent-light/20">
                  <div class="font-medium text-ecomac-primary mb-1">Admin:</div>
                  <div class="font-mono text-xs">admin@ecomac.cl</div>
                </div>
              </div>
              
              <!-- Tablet/Desktop: Grid layout -->
              <div class="hidden sm:block space-y-2">
                <div class="grid grid-cols-3 gap-2 p-2 bg-white bg-opacity-50 rounded">
                  <span class="font-medium text-ecomac-primary">Cliente:</span>
                  <span class="col-span-2 font-mono text-xs">cliente@ecomac.cl</span>
                </div>
                <div class="grid grid-cols-3 gap-2 p-2 bg-white bg-opacity-50 rounded">
                  <span class="font-medium text-ecomac-primary">Líder:</span>
                  <span class="col-span-2 font-mono text-xs">lider@ecomac.cl</span>
                </div>
                <div class="grid grid-cols-3 gap-2 p-2 bg-white bg-opacity-50 rounded">
                  <span class="font-medium text-ecomac-primary">Admin:</span>
                  <span class="col-span-2 font-mono text-xs">admin@ecomac.cl</span>
                </div>
              </div>
              
              <div class="p-2 sm:p-3 bg-white bg-opacity-70 rounded text-center border border-accent-light">
                <span class="font-medium text-ecomac-dark text-xs sm:text-sm">Contraseña común: </span>
                <span class="font-mono text-ecomac-primary font-bold text-xs sm:text-sm">password123</span>
              </div>
            </div>
          </div>
          
          <!-- Login Form -->
          <form @submit.prevent="handleLogin" class="space-y-4 sm:space-y-6">
            <div>
              <label class="block text-sm font-medium text-primary mb-2">
                Correo Electrónico
              </label>
              <input 
                v-model="email" 
                type="email" 
                class="input-field w-full h-12 px-4 text-base sm:text-sm"
                placeholder="ejemplo@ecomac.cl"
                autocomplete="email"
                required
              />
            </div>
            
            <div>
              <label class="block text-sm font-medium text-primary mb-2">
                Contraseña
              </label>
              <input 
                v-model="password" 
                type="password" 
                class="input-field w-full h-12 px-4 text-base sm:text-sm"
                placeholder="••••••••"
                autocomplete="current-password"
                required
              />
            </div>
            
            <button
              type="submit"
              class="btn-primary w-full h-12 sm:h-auto flex items-center justify-center space-x-2 text-base sm:text-sm font-medium"
              :disabled="loading"
            >
              <span v-if="loading" class="animate-spin h-5 w-5 border-2 border-white border-r-transparent rounded-full"></span>
              <span>{{ loading ? 'Iniciando sesión...' : 'Iniciar Sesión' }}</span>
            </button>
          </form>
          
          <!-- Error Message -->
          <div v-if="error" class="mt-4 sm:mt-6 p-3 sm:p-4 bg-error-light bg-opacity-10 border border-error-light rounded-lg animate-shake">
            <div class="flex items-center justify-center space-x-2">
              <svg class="h-5 w-5 text-error flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
              <p class="text-error text-sm font-medium text-center flex-1">{{ error }}</p>
            </div>
          </div>
          
          <!-- Footer -->
          <div class="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-100 lg:border-gray-200 text-center">
            <p class="text-xs text-gray-500 lg:text-gray-600">
              © {{ new Date().getFullYear() }} Ecomac. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../store/authStore';
import { EcomacLogo } from '../components';

const router = useRouter();
const authStore = useAuthStore();

const email = ref('');
const password = ref('');
const loading = ref(false);
const error = ref('');

async function handleLogin() {
  if (!email.value || !password.value) {
    error.value = 'Por favor completa todos los campos';
    return;
  }
  
  loading.value = true;
  error.value = '';
  
  try {
    await authStore.login(email.value, password.value);
    
    // Redirect based on user role
    await router.push('/workspace');
    
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Error al iniciar sesión';
  } finally {
    loading.value = false;
  }
}
</script>

